import { RequestService } from '@tcc-online/request-service';
import { Report, ReportResult } from '@tcc-online/output-report';

const AdminReportsService = {
    getReports,
    getResults,
    getResult,
};

const createUrl = (params: {
    productType: number;
    projectId: number;
    jobMatch?: boolean;
    reportId?: number;
}) => {
    const { productType, projectId, jobMatch, reportId } = params;
    let url = `/admin/products/${productType}/projects/${projectId}/${!jobMatch ? 'reports' : 'job-matching-reports'}`;
    if (reportId) {
        url += `/${reportId}`;
    }
    return url;
};

const createResultsUrl = (params: {
    productType: number;
    projectId: number;
    reportId: number;
    resultId?: number;
    jobMatch?: boolean;
}) => {
    const { productType, projectId, jobMatch, resultId, reportId } = params;

    let url = `${createUrl({ productType, projectId, reportId, jobMatch })}/results`;
    if (resultId) {
        url += `/${resultId}`;
    }
    return url;
};

export interface BasePayload {
    productType: number;
    projectId: number;
    jobMatch?: boolean;
}

async function getReports(payload: BasePayload & { limit?: number }) {
    const { productType, projectId, jobMatch, limit = 100 } = payload;
    return await RequestService.get<Report[]>(
        createUrl({ productType, projectId, jobMatch }),
        { limit },
    );
}

export interface ReportPayload extends BasePayload {
    reportId: number;
}

async function getResults(payload: ReportPayload) {
    const { productType, projectId, reportId, jobMatch } = payload;
    return await RequestService.get<ReportResult[]>(
        createResultsUrl({ productType, projectId, reportId, jobMatch }),
    );
}

export interface ResultPayload extends ReportPayload {
    resultId: number;
}

async function getResult(payload: ResultPayload) {
    const { productType, projectId, reportId, resultId, jobMatch } = payload;
    return await RequestService.get<ReportResult>(
        createResultsUrl({
            productType,
            projectId,
            reportId,
            resultId,
            jobMatch,
        }),
    );
}

export default AdminReportsService;
